import React from 'react';
import SpecificationsTable from './SpecificationsTable';
import TemperatureSettingsTable from './TemperatureSettingsTable';
import WarmingSystemFeatures from './WarmingSystemFeatures';

const Warmingunit = () => {
  return (
    <>
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>Wallabies Forced Air Patient Warming Unit</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section
        className="py-5"
        style={{
          backgroundColor: '#e9f7fd', // Light blue background color
        }}
      >
        <div className="container">
          <div className="row d-flex align-items-center">
            <div className="col-12 col-md-6 mb-4 mb-md-0">
              <img
                src="/images/102.jpg"
                alt="Warming Unit"
                className="img-fluid rounded shadow-lg"
                style={{ maxWidth: '100%' }}
              />
            </div>

            <div className="col-12 col-md-6">
              <div className="specifications-table-container">
                <SpecificationsTable />
              </div>
            </div>
          </div>

          <div className="mt-5">
            <TemperatureSettingsTable />
          </div>

          <div className="mt-5">
            <WarmingSystemFeatures />
          </div>
        </div>
      </section>
    </>
  );
};

export default Warmingunit;
